// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$resolve(url) {url = importMap[url] || url;return publicUrl + url;}newRequire.resolve = $parcel$resolve;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"9KkEN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlertDialog", ()=>AlertDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAria = require("react-aria");
var _reactAriaComponents = require("react-aria-components");
var _button = require("./Button");
var _dialog = require("./Dialog");
'use client';
function AlertDialog({ title, variant, cancelLabel, actionLabel, onAction, children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
        role: "alertdialog",
        ...props,
        children: ({ close })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
                        slot: "title",
                        className: "text-xl font-semibold leading-6 my-0",
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `w-6 h-6 absolute right-6 top-6 stroke-2 ${variant === 'destructive' ? 'text-red-500' : 'text-blue-500'}`,
                        children: variant === 'destructive' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertCircleIcon), {
                            "aria-hidden": true
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.InfoIcon), {
                            "aria-hidden": true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mt-3 text-slate-500 dark:text-zinc-400",
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-6 flex justify-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "secondary",
                                onPress: close,
                                children: cancelLabel || 'Cancel'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: variant === 'destructive' ? 'destructive' : 'primary',
                                autoFocus: true,
                                onPress: (0, _reactAria.chain)(onAction, close),
                                children: actionLabel
                            })
                        ]
                    })
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["AlertCircleIcon","gpCZd","default"],["InfoIcon","bTmmM","default"]],"react":"a1TxN","react-aria":"ij7eS","react-aria-components":"2f4nH","./Button":"hk9LL","./Dialog":"cRN3c","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gpCZd":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CircleAlert);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const CircleAlert = (0, _createLucideIconJsDefault.default)("circle-alert", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bTmmM":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Info);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const Info = (0, _createLucideIconJsDefault.default)("info", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e905L":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CloudSun);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 1.41 1.41",
            key: "149t6j"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "m19.07 4.93-1.41 1.41",
            key: "1shlcs"
        }
    ],
    [
        "path",
        {
            d: "M15.947 12.65a4 4 0 0 0-5.925-4.128",
            key: "dpwdj0"
        }
    ],
    [
        "path",
        {
            d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z",
            key: "s09mg5"
        }
    ]
];
const CloudSun = (0, _createLucideIconJsDefault.default)("cloud-sun", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dMqjU":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Dessert);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "4",
            r: "2",
            key: "muu5ef"
        }
    ],
    [
        "path",
        {
            d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
            key: "lfo06j"
        }
    ],
    [
        "path",
        {
            d: "M3.2 14.8a9 9 0 0 0 17.6 0",
            key: "12xarc"
        }
    ]
];
const Dessert = (0, _createLucideIconJsDefault.default)("dessert", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"csbic":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Droplet);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
            key: "c7niix"
        }
    ]
];
const Droplet = (0, _createLucideIconJsDefault.default)("droplet", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"itGFz":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Droplets);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
            key: "1ptgy4"
        }
    ],
    [
        "path",
        {
            d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
            key: "1sl1rz"
        }
    ]
];
const Droplets = (0, _createLucideIconJsDefault.default)("droplets", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7C0UI":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Funnel);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
            key: "sc7q7i"
        }
    ]
];
const Funnel = (0, _createLucideIconJsDefault.default)("funnel", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2oAid":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>RefreshCw);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const RefreshCw = (0, _createLucideIconJsDefault.default)("refresh-cw", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3FWGC":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>SlidersVertical);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "line",
        {
            x1: "4",
            x2: "4",
            y1: "21",
            y2: "14",
            key: "1p332r"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "4",
            y1: "10",
            y2: "3",
            key: "gb41h5"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "21",
            y2: "12",
            key: "hf2csr"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "3",
            key: "1kfi7u"
        }
    ],
    [
        "line",
        {
            x1: "20",
            x2: "20",
            y1: "21",
            y2: "16",
            key: "1lhrwl"
        }
    ],
    [
        "line",
        {
            x1: "20",
            x2: "20",
            y1: "12",
            y2: "3",
            key: "16vvfq"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "6",
            y1: "14",
            y2: "14",
            key: "1uebub"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "14",
            y1: "8",
            y2: "8",
            key: "1yglbp"
        }
    ],
    [
        "line",
        {
            x1: "18",
            x2: "22",
            y1: "16",
            y2: "16",
            key: "1jxqpz"
        }
    ]
];
const SlidersVertical = (0, _createLucideIconJsDefault.default)("sliders-vertical", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7xMzH":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Sun);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M12 20v2",
            key: "1lh1kg"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 1.41 1.41",
            key: "149t6j"
        }
    ],
    [
        "path",
        {
            d: "m17.66 17.66 1.41 1.41",
            key: "ptbguv"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "m6.34 17.66-1.41 1.41",
            key: "1m8zz5"
        }
    ],
    [
        "path",
        {
            d: "m19.07 4.93-1.41 1.41",
            key: "1shlcs"
        }
    ]
];
const Sun = (0, _createLucideIconJsDefault.default)("sun", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"KyXkF":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>SunDim);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ],
    [
        "path",
        {
            d: "M12 4h.01",
            key: "1ujb9j"
        }
    ],
    [
        "path",
        {
            d: "M20 12h.01",
            key: "1ykeid"
        }
    ],
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M4 12h.01",
            key: "158zrr"
        }
    ],
    [
        "path",
        {
            d: "M17.657 6.343h.01",
            key: "31pqzk"
        }
    ],
    [
        "path",
        {
            d: "M17.657 17.657h.01",
            key: "jehnf4"
        }
    ],
    [
        "path",
        {
            d: "M6.343 17.657h.01",
            key: "gdk6ow"
        }
    ],
    [
        "path",
        {
            d: "M6.343 6.343h.01",
            key: "1uurf0"
        }
    ]
];
const SunDim = (0, _createLucideIconJsDefault.default)("sun-dim", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jeVaH":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Twitter);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
            key: "pff0z6"
        }
    ]
];
const Twitter = (0, _createLucideIconJsDefault.default)("twitter", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kG5mF":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _agapanthusJpgAsWebp = require("url:./plants/agapanthus.jpg?as=webp");
var _agapanthusJpgAsWebpDefault = parcelHelpers.interopDefault(_agapanthusJpgAsWebp);
var _aloeJpgAsWebp = require("url:./plants/aloe.jpg?as=webp");
var _aloeJpgAsWebpDefault = parcelHelpers.interopDefault(_aloeJpgAsWebp);
var _dracaenaJpgAsWebp = require("url:./plants/dracaena.jpg?as=webp");
var _dracaenaJpgAsWebpDefault = parcelHelpers.interopDefault(_dracaenaJpgAsWebp);
var _fernJpgAsWebp = require("url:./plants/fern.jpg?as=webp");
var _fernJpgAsWebpDefault = parcelHelpers.interopDefault(_fernJpgAsWebp);
var _figJpgAsWebp = require("url:./plants/fig.jpg?as=webp");
var _figJpgAsWebpDefault = parcelHelpers.interopDefault(_figJpgAsWebp);
var _gardeniaJpgAsWebp = require("url:./plants/gardenia.jpg?as=webp");
var _gardeniaJpgAsWebpDefault = parcelHelpers.interopDefault(_gardeniaJpgAsWebp);
var _ivyJpgAsWebp = require("url:./plants/ivy.jpg?as=webp");
var _ivyJpgAsWebpDefault = parcelHelpers.interopDefault(_ivyJpgAsWebp);
var _jacarandaJpgAsWebp = require("url:./plants/jacaranda.jpg?as=webp");
var _jacarandaJpgAsWebpDefault = parcelHelpers.interopDefault(_jacarandaJpgAsWebp);
var _maidenhairJpgAsWebp = require("url:./plants/maidenhair.jpg?as=webp");
var _maidenhairJpgAsWebpDefault = parcelHelpers.interopDefault(_maidenhairJpgAsWebp);
var _moneyJpgAsWebp = require("url:./plants/money.jpg?as=webp");
var _moneyJpgAsWebpDefault = parcelHelpers.interopDefault(_moneyJpgAsWebp);
var _monsteraJpgAsWebp = require("url:./plants/monstera.jpg?as=webp");
var _monsteraJpgAsWebpDefault = parcelHelpers.interopDefault(_monsteraJpgAsWebp);
var _morningJpgAsWebp = require("url:./plants/morning.jpg?as=webp");
var _morningJpgAsWebpDefault = parcelHelpers.interopDefault(_morningJpgAsWebp);
var _nasturtiumJpgAsWebp = require("url:./plants/nasturtium.jpg?as=webp");
var _nasturtiumJpgAsWebpDefault = parcelHelpers.interopDefault(_nasturtiumJpgAsWebp);
var _oleanderJpgAsWebp = require("url:./plants/oleander.jpg?as=webp");
var _oleanderJpgAsWebpDefault = parcelHelpers.interopDefault(_oleanderJpgAsWebp);
var _poplarJpgAsWebp = require("url:./plants/poplar.jpg?as=webp");
var _poplarJpgAsWebpDefault = parcelHelpers.interopDefault(_poplarJpgAsWebp);
var _spiderJpgAsWebp = require("url:./plants/spider.jpg?as=webp");
var _spiderJpgAsWebpDefault = parcelHelpers.interopDefault(_spiderJpgAsWebp);
var _starJpgAsWebp = require("url:./plants/star.jpg?as=webp");
var _starJpgAsWebpDefault = parcelHelpers.interopDefault(_starJpgAsWebp);
var _treeFernJpgAsWebp = require("url:./plants/tree_fern.jpg?as=webp");
var _treeFernJpgAsWebpDefault = parcelHelpers.interopDefault(_treeFernJpgAsWebp);
var _xmasJpgAsWebp = require("url:./plants/xmas.jpg?as=webp");
var _xmasJpgAsWebpDefault = parcelHelpers.interopDefault(_xmasJpgAsWebp);
var _zzJpgAsWebp = require("url:./plants/zz.jpg?as=webp");
var _zzJpgAsWebpDefault = parcelHelpers.interopDefault(_zzJpgAsWebp);
exports.default = [
    {
        id: 1,
        common_name: 'Aloe',
        scientific_name: [
            'Aloe vera'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _aloeJpgAsWebpDefault.default)
        }
    },
    {
        id: 2,
        common_name: 'Blue Jacaranda',
        scientific_name: [
            'Jacaranda mimosifolia'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _jacarandaJpgAsWebpDefault.default)
        }
    },
    {
        id: 3,
        common_name: 'Oleander',
        scientific_name: [
            'Nerium oleander'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _oleanderJpgAsWebpDefault.default)
        }
    },
    {
        id: 4,
        common_name: 'Poplar',
        scientific_name: [
            'Populus'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _poplarJpgAsWebpDefault.default)
        }
    },
    {
        id: 5,
        common_name: 'Zanzibar Gem',
        scientific_name: [
            'Zamioculcas'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _zzJpgAsWebpDefault.default)
        }
    },
    {
        id: 6,
        common_name: 'Morning Glory',
        scientific_name: [
            'Ipomoea'
        ],
        watering: 'Frequent',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _morningJpgAsWebpDefault.default)
        }
    },
    {
        id: 7,
        common_name: 'Christmas Bush',
        scientific_name: [
            'Ceratopetalum gummiferum'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _xmasJpgAsWebpDefault.default)
        }
    },
    {
        id: 8,
        common_name: 'Gardenia',
        scientific_name: [
            'Gardenia jasminoides'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _gardeniaJpgAsWebpDefault.default)
        }
    },
    {
        id: 9,
        common_name: 'Spider Plant',
        scientific_name: [
            'Chlorophytum comosum'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _spiderJpgAsWebpDefault.default)
        }
    },
    {
        id: 10,
        common_name: 'Chinese Money Plant',
        scientific_name: [
            'Pilea peperomioides'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _moneyJpgAsWebpDefault.default)
        }
    },
    {
        id: 11,
        common_name: 'Fiddle Leaf Fig',
        scientific_name: [
            'Ficus lyrata'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _figJpgAsWebpDefault.default)
        }
    },
    {
        id: 12,
        common_name: 'Tuberous Sword Fern',
        scientific_name: [
            'Nephrolepis cordifolia'
        ],
        watering: 'Frequent',
        sunlight: [
            'part shade'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _fernJpgAsWebpDefault.default)
        }
    },
    {
        id: 13,
        common_name: 'Star Jasmine',
        scientific_name: [
            'Trachelospermum jasminoides'
        ],
        watering: 'Frequent',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _starJpgAsWebpDefault.default)
        }
    },
    {
        id: 14,
        common_name: 'Split-leaf Philodendron',
        scientific_name: [
            'Monstera deliciosa'
        ],
        watering: 'Frequent',
        sunlight: [
            'part shade'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _monsteraJpgAsWebpDefault.default)
        }
    },
    {
        id: 15,
        common_name: 'Agapanthus',
        scientific_name: [
            'Agapanthus praecox'
        ],
        watering: 'Minimum',
        sunlight: [
            'full sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _agapanthusJpgAsWebpDefault.default)
        }
    },
    {
        id: 16,
        common_name: 'Tree Fern',
        scientific_name: [
            'Cyatheaceae'
        ],
        watering: 'Frequent',
        sunlight: [
            'part sun'
        ],
        cycle: 'Annual',
        default_image: {
            thumbnail: (0, _treeFernJpgAsWebpDefault.default)
        }
    },
    {
        id: 17,
        common_name: 'Striped Dracaena',
        scientific_name: [
            'Asparagaceae'
        ],
        watering: 'Average',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _dracaenaJpgAsWebpDefault.default)
        }
    },
    {
        id: 18,
        common_name: 'Delta Maidenhair Fern',
        scientific_name: [
            'Adiantum raddianum'
        ],
        watering: 'Average',
        sunlight: [
            'part shade'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _maidenhairJpgAsWebpDefault.default)
        }
    },
    {
        id: 19,
        common_name: 'Ivy',
        scientific_name: [
            'Hedera'
        ],
        watering: 'Frequent',
        sunlight: [
            'part sun'
        ],
        cycle: 'Perennial',
        default_image: {
            thumbnail: (0, _ivyJpgAsWebpDefault.default)
        }
    },
    {
        id: 20,
        common_name: 'Nasturtium',
        scientific_name: [
            'Tropaeolum'
        ],
        watering: 'Average',
        sunlight: [
            'full sun'
        ],
        cycle: 'Annual',
        default_image: {
            thumbnail: (0, _nasturtiumJpgAsWebpDefault.default)
        }
    }
];

},{"url:./plants/agapanthus.jpg?as=webp":"3Vi6L","url:./plants/aloe.jpg?as=webp":"8WGfs","url:./plants/dracaena.jpg?as=webp":"cUKL2","url:./plants/fern.jpg?as=webp":"fChVQ","url:./plants/fig.jpg?as=webp":"1HHWY","url:./plants/gardenia.jpg?as=webp":"68gwm","url:./plants/ivy.jpg?as=webp":"1PMZu","url:./plants/jacaranda.jpg?as=webp":"jrDBk","url:./plants/maidenhair.jpg?as=webp":"eO5Y0","url:./plants/money.jpg?as=webp":"dC83U","url:./plants/monstera.jpg?as=webp":"h7vfZ","url:./plants/morning.jpg?as=webp":"3bjOf","url:./plants/nasturtium.jpg?as=webp":"2FKPh","url:./plants/oleander.jpg?as=webp":"dAuvx","url:./plants/poplar.jpg?as=webp":"gvkLq","url:./plants/spider.jpg?as=webp":"3hsRp","url:./plants/star.jpg?as=webp":"hONAA","url:./plants/tree_fern.jpg?as=webp":"c9SOL","url:./plants/xmas.jpg?as=webp":"3CIBh","url:./plants/zz.jpg?as=webp":"8iNAi","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3Vi6L":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("cXaBB");

},{}],"8WGfs":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8mKaA");

},{}],"cUKL2":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1zdL2");

},{}],"fChVQ":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("112xf");

},{}],"1HHWY":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("bHTqg");

},{}],"68gwm":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8iJhr");

},{}],"1PMZu":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3Dclt");

},{}],"jrDBk":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("bsAtG");

},{}],"eO5Y0":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("fgfVd");

},{}],"dC83U":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("6b5bz");

},{}],"h7vfZ":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("enHi9");

},{}],"3bjOf":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("59LDD");

},{}],"2FKPh":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("53U7I");

},{}],"dAuvx":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("60Y2E");

},{}],"gvkLq":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("2UjX6");

},{}],"3hsRp":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("jMKg0");

},{}],"hONAA":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("gZb3q");

},{}],"c9SOL":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("antzm");

},{}],"3CIBh":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("61dWU");

},{}],"8iNAi":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kvgco");

},{}]},[], null, "parcelRequire7f0c", {}, "./", "https://reactspectrum.blob.core.windows.net/reactspectrum/cad6874b6af09f6065814a5c198af90648afe240/s2-docs/")

//# sourceMappingURL=react-aria.6c5e0869.js.map
